import { useCallback, useMemo, useState } from "react";
import { ActivityListResponse } from "../entities/AcitivityListResponse";
import ActivityService from "../../../../services/ActivityService";
import unpin from "../../../../assets/img/thumbtack-slash-solid.svg";
import { TranslationService } from "../../../../services/TranslationService";
import { ToastService } from "../../../shared/bootstrap/Toast";
import CompanyService from "../../../../services/CompanyService";

interface PinActivityHookProps {
  data: ActivityListResponse.Item;
  reload: () => void;
}

export const usePinActivityHook = ({ data, reload }: PinActivityHookProps) => {
  const [isPinned, setIsPinned] = useState(data.Pinned);
  const canPin = CompanyService.canPinActivity();

  const togglePinActivity = useCallback(async () => {
    if (!canPin) return;
    const previousState = isPinned;
    const newState = !previousState;

    //Optimistic UI
    setIsPinned(newState);

    try {
      await ActivityService.togglePinActivity(data.ID.toString());
      const message = newState
        ? TranslationService.translate.PinActivitySuccess
        : TranslationService.translate.UnpinActivitySuccess;
      ToastService.showToast(message, undefined, "success");
      reload?.();
    } catch (error) {
      const message = newState
        ? TranslationService.translate.PinActivityError
        : TranslationService.translate.UnpinActivityError;
      ToastService.showToast(message, undefined, "danger");
      setIsPinned(previousState);
    }
  }, [canPin, data.ID, isPinned, reload]);

  const ui = useMemo(
    () => ({
      icon: isPinned ? unpin : "fa-thumbtack",
      tooltip: isPinned
        ? TranslationService.translate.UnpinActivity
        : TranslationService.translate.PinActivity
    }),
    [isPinned]
  );

  return {
    ...ui,
    canPin,
    togglePinActivity
  };
};
